export default __webpack_public_path__ + "static/gatsby_github_deploy_yml-7bb9c5170716fa66607dd5fb7d4f7e61.png";